export const shouldHideATC = (schemaName) => {
  return ['pipsem'].indexOf(schemaName) >= 0;
};

export const getCollectionDetails = (products = []) => {
  if (!products || products.length === 0) return {};
  const hotspots = [];
  const collectionImage = products[0].collectionimage || '';
  products.forEach((product) => {
    const coordinates = {
      hsXPosition: product.hotspot_xpos,
      hsYPosition: product.hotspot_ypos,
      itemId: product.id
    };
    hotspots.push(
      coordinates
    );
  });
  return { hotspots, collectionImage };
};
